import Frame from "@/components/Frame/Frame";
import OrderedList from "@/components/OrderedList/OrderedList";
import { useTranslation } from "@/utils/translations/Translator";
import { Flex, LinkButton, StyledText, Types } from "@emonvia/web-components";
import theme from "@/utils/theme/theme";
import Accordion from "@/components/Accordian/Accordian";
import BookIcon from "@/assets/images/book-icon.svg";
import { Trans } from "react-i18next";
import { FC } from "react";
import { PHASE_ROTATION_URL_BY_LANGUAGE } from "@/utils/constants";
import { getCurrentLanguage } from "@/utils/i18n";

const ReevLink: FC<{ children?: string; url: string }> = ({ children, url }) => (
  <Flex flexDirection="row">
    <LinkButton
      onClick={() => window.open(url, "_blank")}
      label={children}
      look="primary"
      fontType={Types.ns_16_sb}
    />
  </Flex>
);

const EvseIdOrderedFrame = () => {
  const { t } = useTranslation();

  return (
    <Frame>
      <Accordion
        insets={false}
        title={
          <Flex flexDirection="row" alignItems="center" gap={12}>
            <Flex flexDirection="column" gap={12} alignItems="flex-start">
              <img src={BookIcon} alt={`${BookIcon} + img`} />
            </Flex>
            <Flex flexDirection="column" flex={1}>
              <StyledText
                text={t("HOW_IT_WORKS")}
                type={Types.ns_18_sb}
                style={{ fontWeight: 700 }}
                color={theme.colors.primaryBlack}
              />
            </Flex>
          </Flex>
        }
      >
        <Flex style={{ padding: 20, paddingTop: 0, paddingBottom: 15 }}>
          <OrderedList
            items={[
              <StyledText
                key={1}
                text={t("PLEASE_ATTACH_THE_YELLOW_QR_STICKERS")}
                color={theme.colors.primaryBlack}
                type={Types.ns_16_l}
              />,
              <StyledText
                key={2}
                text={t("SCAN_OR_ENTER_THE_INDIVIDUAL_EVSEID")}
                color={theme.colors.primaryBlack}
                type={Types.ns_16_l}
              />,
              <StyledText
                key={3}
                text={
                  <Trans i18nKey="REVIEW_THE_PHASE_ROTATION_FOR_THIS_CONNECTOR">
                    <ReevLink url={PHASE_ROTATION_URL_BY_LANGUAGE[getCurrentLanguage()]} />
                  </Trans>
                }
                color={theme.colors.primaryBlack}
                type={Types.ns_16_l}
              />,
              <StyledText
                key={4}
                text={t("REVIEW_THE_MAX_LOAD_OF_THE_CONNECTOR")}
                color={theme.colors.primaryBlack}
                type={Types.ns_16_l}
              />
            ]}
          />
        </Flex>
      </Accordion>
    </Frame>
  );
};

export default EvseIdOrderedFrame;
